
import { defineComponent, ref, reactive, toRefs, onMounted, watchEffect, computed, watch, nextTick } from 'vue'
import { SearchOutlined, CloseCircleFilled, DeleteOutlined } from '@ant-design/icons-vue'
import { askApi } from '@/api/index'
import Askcollapse from '@/components/asktheSecretary/askcollapse.vue'
import Nodata from '@/components/page/nodata.vue'
export default defineComponent({
  components: {
    SearchOutlined,
    CloseCircleFilled,
    Askcollapse,
    DeleteOutlined,
    Nodata
  },
  props: {
    token: {
      type: String,
      default: () => {
        return ''
      }
    },
    source: {
      type: String,
      default: () => {
        return ''
      }
    },
    navObj: {
      type: Object,
      default: () => {
        return {}
      }
    },
    theme: {
      type: String,
      default: () => {
        return 'light'
      }
    },
    tags: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  setup(props: any, content: any) {
    const pageData: any = reactive({
      value: '',
      showInput: true,
      placeholder: '请输入代码/简拼/名称',
      options: [],
      getPopupContainer: (e: HTMLElement) => e.parentNode,
      historyData: JSON.parse(sessionStorage.getItem('askingHistory') || '[]') || [],
      historyOption: [],
      searchstr: '',
      searchObj: {
        InstExt: [],
        KeyWords: []
      },
      tags: {},
      activeLi: '',
      activeindex: -1,
      showDropdown: false,
      width: 8 + 'px',
      isComposing: false, // 标记是否正在输入中文
    })
    const askingselect = ref()
    
    // 防抖函数
    function debounce(func: Function, wait: number) {
      let timeout: any
      return function executedFunction(this: any, ...args: any[]) {
        const later = () => {
          clearTimeout(timeout)
          func.apply(this, args)
        }
        clearTimeout(timeout)
        timeout = setTimeout(later, wait)
      }
    }
    
    function handleChange(e: any, value: any, option: any) {
      pageData.value = ''
      pageData.searchstr = ''
      let obj = {}
      // 标识----如果已经加入标签，则不需要再push
      let flag = false
      if (typeof value.Id === 'number') {
        // 如果有该属性，则证明是股票
        obj = value
        if ((pageData.searchObj.InstExt || []).map((item: any) => item.Id).indexOf(value.Id) < 0) {
          pageData.searchObj.InstExt.push(obj)
          flag = true
        }

      } else {
        if (pageData.searchObj.KeyWords.indexOf(value.Id) < 0) {
          pageData.searchObj.KeyWords.push(value.Id)
          flag = true
          obj = {
            value: value.Id,
            Id: value.Id,
            Code: value.Id
          }
        }
      }
      if (flag) {

        content.emit('checkStock', obj)
        pageData.historyData.push(obj)
        hanldeHistory()

        
      } else if (props.source === 'hot') {
        content.emit('checkStock', obj)
      }
      search()
      e.stopPropagation()
      return false
    }
    // 处理中文输入开始
    function handleCompositionStart() {
      pageData.isComposing = true
    }
    
    // 处理中文输入结束
    function handleCompositionEnd() {
      pageData.isComposing = false
      // 输入完成后触发搜索
      if (pageData.value) {
        debouncedSearchValue(pageData.value)
      }
    }
    
    // 处理输入框 change 事件
    function handleInputChange(val: string) {
      // 如果正在输入中文，不触发搜索（等待 compositionend 事件）
      if (pageData.isComposing) {
        return
      }
      pageData.searchstr =  pageData.value
      pageData.showDropdown = true
      // console.log('handleInputChange===', pageData.value,pageData.searchstr)
      // 只有在非中文输入状态下才触发搜索（使用防抖版本）
      debouncedSearchValue(val)
    }
    
    function searchValue(val: string) {
      if (!pageData.value) return
      pageData.searchstr = pageData.value
      const data: any = {}
      data.data = {
        markettype: ['CNX'],
        marketcode: 'sh,sz,bj',
        key: pageData.value,
        active: true
      }
      data.headers = {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
      // pageData.isLoadSearch = true
      askApi.searchStock(data).then((res: any) => {
        nextTick(() => {
          // pageData.options = (res.Data || []).filter((item: any) => item.MarketCode === 'sh' || item.MarketCode === 'sz')
          pageData.options = (res.Data || [])
          pageData.activeLi = pageData.options[0].Id
          if(pageData.options.length) {
            pageData.activeindex = 0
          }
          console.log('historypageData.options===', res.Data)
        })


      })
    }
    
    // 创建防抖版本的 searchValue，延迟 300ms
    const debouncedSearchValue = debounce(searchValue, 300)
    pageData.selectOption = computed(() => {
      const history = pageData.historyOption
      console.log('history===', history, pageData.options)
      const data = !pageData.searchstr.length && history.length ? history : pageData.options
      return data
    })
    pageData.firstActiveValue = computed(() => {
      if ((pageData.selectOption || []).length) {
        return [((pageData.selectOption || [])[0] || {}).Id]
      } else {
        return ''
      }
    })
    function handlefocusInput() {
      pageData.activeLi = ''
      pageData.activeindex = -1
      askingselect.value.focus()
    }
    function focusSelect() {
      pageData.showDropdown = true
      pageData.activeLi = ''
      pageData.searchstr = ''
      pageData.activeindex = -1
      window.addEventListener('keydown', handlekeyFn, !0)
      let history = (JSON.parse(sessionStorage.getItem('askingHistory') || '[]') || []).reverse()
      // 去个重，且只取前10个
      const map = new Map()
      for (const i of history) {
        if (!map.has(i.Id)) {
          map.set(i.Id, i)
        }
      }
      history = [...map.values()]
      pageData.historyOption = history.slice(0, 10)
      console.log('focusSelecthistory===', history)
      // pageData.options = history
      pageData.options = []
      console.log('focusSelectpageData.historyOption===', pageData.historyOption)
      if(! pageData.historyOption.length){
        searchValue(pageData.value)
      }
    }
    // 失去焦点时去搜索
    function blurSelect() {
      console.log('blurSelect===', pageData.options)
      setTimeout(() => {
        pageData.showDropdown = false
        if (!pageData.activeLi) {
          enterSelect()
        }
      }, 400)
    }

    function searchAction(code='') {
      pageData.showDropdown = false

      hanldeHistory()
      pageData.searchstr = ''
      nextTick(() => {
        askingselect.value.blur()
      })
    }
    function search(code='') {
      if (!isEmpty(props.tags)) return
      searchAction()
    }
    
    function isEmpty(obj: any) {
      return Object.keys(obj).length === 0
    }
    async function enterSelect(code ='') {
      console.log('enterSelect===', pageData.activeLi, pageData.value)
      if (!pageData.activeLi && !pageData.value) return
      if (pageData.activeLi) {
        // 选中了下拉框里的内容
        let obj: any = null  // 改为 null 而不是数组
        if (typeof pageData.activeLi === 'number') {
          // 股票
          const filtered = pageData.selectOption.filter((item: any) => item.Id === pageData.activeLi)
          if (filtered.length > 0) {
            obj = filtered[0]  // 取第一个元素，而不是整个数组
            pageData.searchObj.InstExt.push(obj)
          }
        } else if (typeof pageData.activeLi === 'string') {
          obj = {
            value: pageData.activeLi.trim(),
            Id: pageData.activeLi.trim(),
            Code: pageData.activeLi.trim()
          }
        }

        if (obj) {
          console.log('obj===', obj)
          props.tags = obj  // 如果 tags 需要数组格式
          content.emit('checkStock', obj)
          pageData.historyData.push(obj)
          searchAction()
        }
      }
      // pageData.showDropdown = false

      search(code)
    }
    function selectValue(e: any, option: any) { }
    function hanldeHistory() {
      if (pageData.historyData) {
        const history = JSON.parse(sessionStorage.getItem('askingHistory') || '[]') || []
        sessionStorage.setItem('askingHistory', JSON.stringify(pageData.historyData))
      }
    }
    watch(
      () => props.tags,
      () => {
        pageData.value = props.tags?.Code ? props.tags?.Name + '(' + props.tags?.Code + ')' : ''
        console.log('打印===', pageData.value)
      },
      { deep: true }
    )
    function clearHistory() {
      pageData.historyData = []
      pageData.historyOption = []
      pageData.showDropdown = false
      sessionStorage.removeItem('askingHistory')
    }
    function cleartagsCall() {
      content.emit('clearsearch')
    }
    function handlekeyFn(e: any) {
      if (e.code !== 'ArrowDown' && e.code !== 'ArrowUp') return
      // 向下箭头
      if (e.code === 'ArrowDown') {
        pageData.activeindex++
        if (pageData.activeindex >= pageData.selectOption.length) {
          pageData.activeindex = pageData.selectOption.length - 1
        }
        pageData.activeLi = pageData.selectOption[pageData.activeindex].Id
      } else if (e.code === 'ArrowUp') {
        pageData.activeindex--
        if (pageData.activeindex < 0) {
          pageData.activeindex = 0
        }
        pageData.activeLi = pageData.selectOption[pageData.activeindex].Id
      }
      const dom: any = document.querySelector('.searchlist')
      if (pageData.activeindex < 10) {
        dom.scrollTop = 0
      } else {
        dom.scrollTop = pageData.activeindex * 32
      }
    }
    function inputKeyup(e: any) {
      if (e.code === 'Enter') {
        enterSelect('Enter')
      }
    }
    return {
      ...toRefs(pageData),
      handleChange,
      searchValue,
      focusSelect,
      clearHistory,
      blurSelect,
      selectValue,
      cleartagsCall,
      askingselect,
      enterSelect,
      handlekeyFn,
      handlefocusInput,
      inputKeyup,
      isEmpty,
      handleCompositionStart,
      handleCompositionEnd,
      handleInputChange
    }
  }
})
